module.exports = __webpack_public_path__ + "static/dontThink-7448501721a8d0f5e71b5135096cd507.webp";